import styled from 'styled-components';

export const Container = styled.div`
  .new-notification {
    background-color: #f5f5f5;
  }
`;
